(() => {
    window.addEventListener("load", () => {
        document.querySelectorAll("a[href^='tel']").forEach((e) => {
            e.addEventListener("click", (n) => {
                var t = e.href,
                    a = t.replace("tel:", "");
                typeof _paq < "u" && _paq.push(["trackEvent", "Kontakt", "Klick auf Telefonnummer", a]),
                typeof gtag < "u" &&
                gtag("event", "klick_telefonnummer", {
                    event_name: "klick_telefonnummer",
                    event_category: "Button",
                    event_action: "Klick auf Telefonnummer",
                    event_label: a,
                });
            });
        }),
            document.querySelectorAll("a[href^='mailto']").forEach((e) => {
                e.addEventListener("click", (n) => {
                    var t = e.href,
                        a = t.replace("mailto:", "");
                    typeof _paq < "u" && _paq.push(["trackEvent", "Kontakt", "Klick auf E-Mail", a]),
                    typeof gtag < "u" &&
                    gtag("event", "klick_email", {
                        event_name: "klick_email",
                        event_category: "Kontakt",
                        event_action: "Klick auf E-Mail",
                        event_label: a,
                    });
                });
            }),
            document.querySelectorAll(".btn, button").forEach((e) => {
                e.addEventListener("click", (n) => {
                    let t = e.href;
                    typeof t < "u"
                        ? (typeof _paq < "u" && _paq.push(["trackEvent", "Button", "Klick auf Button", t]),
                        typeof gtag < "u" &&
                        gtag("event", "klick_button", {
                            event_name: "klick_button",
                            event_category: "Button",
                            event_action: "Klick auf Button",
                            event_label: t,
                        }))
                        : e.childNodes.length > 1
                            ? (typeof _paq < "u" &&
                            _paq.push(["trackEvent", "Button", "Klick auf Button", e.childNodes[1].innerText]),
                            typeof gtag < "u" &&
                            gtag("event", "klick_button", {
                                event_name: "klick_button",
                                event_category: "Button",
                                event_action: "Klick auf Button",
                                event_label: e.childNodes[1].innerText,
                            }))
                            : (typeof _paq < "u" && _paq.push(["trackEvent", "Button", "Klick auf Button", e.innerText]),
                            typeof gtag < "u" &&
                            gtag("event", "klick_button", {
                                event_name: "klick_button",
                                event_category: "Button",
                                event_action: "Klick auf Button",
                                event_label: e.innerText,
                            }));
                });
            }),
            document.querySelectorAll('a[href*="/anmeldung-buchlaunch/"]').forEach((e) => {
                e.addEventListener("click", (n) => {
                    let t = e.href;
                    if (!t || t === null) return !1;
                    typeof _paq < "u" && _paq.push(["trackEvent", "Button", "Klick auf Anmeldung Buchlaunch Link", t]),
                    typeof gtag < "u" &&
                    gtag("event", "klick_anmeldung_buchlaunch_link", {
                        event_category: "Button",
                        event_action: "Klick auf Anmeldung Buchlaunch Link",
                        event_label: t,
                    });
                });
            }),

            // Wählt Links aus, die entweder amazon.de oder amzn.eu im href enthalten
            document.querySelectorAll('a[href*="amazon.de/"], a[href*="amzn.eu/"]').forEach((e) => {
                e.addEventListener("click", (n) => {
                    let t = e.href;

                    // Sicherheitscheck für die URL
                    if (!t) return;

                    // Tracking für Matomo (_paq)
                    if (typeof _paq !== "undefined") {
                        _paq.push(["trackEvent", "Button", "Klick auf Amazon Link", t]);
                    }

                    // Tracking für Google Analytics (gtag)
                    if (typeof gtag !== "undefined") {
                        gtag("event", "klick_amazon_link", {
                            event_category: "Button",
                            event_action: "Klick auf Amazon Link",
                            event_label: t,
                        });
                    }
                });
            });
    }),
        document.addEventListener("wpcf7mailsent", function (e) {
            let n = e.detail.contactFormId;
            n === 285 || n === "285"
                ? (typeof _paq < "u" &&
                _paq.push(["trackEvent", "Kontakt", "Anmeldung Buchlaunch abgesendet", "Anmeldung Buchlaunch"]),
                typeof gtag < "u" &&
                gtag("event", "anmeldung_buchlaunch_abgesendet", {
                    event_category: "Kontakt",
                    event_action: "abgesendet",
                    event_label: "Anmeldung Buchlaunch",
                    formId: n || null,
                }))
                : (typeof _paq < "u" && _paq.push(["trackEvent", "Kontakt", "CF7 Formular abgesendet", "CF7 Formular"]),
                typeof gtag < "u" &&
                gtag("event", "c7_formular_abgesendet", {
                    event_category: "Kontakt",
                    event_action: "abgesendet",
                    event_label: "CF7 Formular",
                    formId: n || null,
                }));
        });
})();
//# sourceMappingURL=tracking.js.map
